/**
 * Route table.
 *
 * Public auth routes (/login, /register) render outside the shell. Everything
 * else is wrapped by RequireAuth (a no-op when AUTH_MODE=none), and the
 * user-administration console additionally by RequireSysadmin.
 *
 *   /              — activity dashboard
 *   /tool          — single-tool run (§5.1)
 *   /wizard        — full-pipeline stepper (§5.2)
 *   /runs          — run list (F2)
 *   /runs/:id      — run detail drill-down (F2)
 *   /approvals     — approvals inbox (F2)
 *   /audit         — audit assistance chat
 *   /admin/users   — user administration (sysadmin)
 *   /admin/customers — customer administration (sysadmin)
 *   *              — friendly 404 inside the shell
 */
import { Route, Routes } from "react-router-dom";
import { AppShell } from "./layout/AppShell";
import { DashboardPage } from "./pages/DashboardPage";
import { WizardPage } from "./pages/WizardPage";
import { SingleToolPage } from "./pages/SingleToolPage";
import { RunsPage } from "./pages/RunsPage";
import { RunDetailPage } from "./pages/RunDetailPage";
import { ApprovalsPage } from "./pages/ApprovalsPage";
import { AuditPage } from "./pages/AuditPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { AdminUsersPage } from "./pages/AdminUsersPage";
import { AdminCustomersPage } from "./pages/AdminCustomersPage";
import { LoginPage } from "./auth/LoginPage";
import { RegisterPage } from "./auth/RegisterPage";
import { RequireAuth, RequireSysadmin, RedirectIfAuthed } from "./auth/RequireAuth";

export default function App() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <RedirectIfAuthed>
            <LoginPage />
          </RedirectIfAuthed>
        }
      />
      <Route
        path="/register"
        element={
          <RedirectIfAuthed>
            <RegisterPage />
          </RedirectIfAuthed>
        }
      />

      <Route element={<RequireAuth />}>
        <Route element={<AppShell />}>
          <Route index element={<DashboardPage />} />
          <Route path="wizard" element={<WizardPage />} />
          <Route path="tool" element={<SingleToolPage />} />
          <Route path="runs" element={<RunsPage />} />
          <Route path="runs/:id" element={<RunDetailPage />} />
          <Route path="approvals" element={<ApprovalsPage />} />
          <Route path="audit" element={<AuditPage />} />
          <Route element={<RequireSysadmin />}>
            <Route path="admin/users" element={<AdminUsersPage />} />
            <Route path="admin/customers" element={<AdminCustomersPage />} />
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
    </Routes>
  );
}
